import axios from 'axios';

export const HTTP = axios.create({
  // baseURL: `http://216.137.189.45/la3btnaAPI/APIs/`
  baseURL: `https://gengplay.com/la3btnaAPI/APIs`
})

